import type { ImportedVectorData } from '../data/import/model';
import type { VectorSourceDescriptor } from '../data/model';
import {
  createInitialLayerLabelConfiguration,
  type InitialLabelContrast,
} from '../labels/defaults';
import { createDefaultLayerPopupConfiguration } from '../popups/defaults';
import { createDefaultVectorLayerStyle } from '../styles/defaults';
import type { LayerDefinition } from './model';

export type ProjectIdPrefix = 'lyr' | 'src';
export type ProjectIdFactory = (prefix: ProjectIdPrefix) => string;

const createProjectId: ProjectIdFactory = (prefix) => `${prefix}_${crypto.randomUUID()}`;

export interface ImportedVectorProjectItems {
  readonly source: VectorSourceDescriptor;
  readonly layer: LayerDefinition;
}

export function createImportedVectorProjectItems(
  imported: ImportedVectorData,
  createId: ProjectIdFactory = createProjectId,
  initialLabelContrast: InitialLabelContrast = 'light',
): ImportedVectorProjectItems {
  const sourceId = createId('src');
  const source: VectorSourceDescriptor = {
    id: sourceId,
    name: imported.suggestedLayerName,
    kind: 'vector',
    crs: imported.crs,
    data: imported.data,
    provenance: imported.provenance,
    featureCount: imported.data.features.length,
    fields: imported.fields,
    geometry: imported.geometry,
    extent: imported.extent,
    warnings: imported.warnings,
  };
  const layer: LayerDefinition = {
    id: createId('lyr'),
    sourceId,
    name: imported.suggestedLayerName,
    visible: true,
    displayFilter: null,
    style: createDefaultVectorLayerStyle(),
    labels: createInitialLayerLabelConfiguration(source, initialLabelContrast),
    popup: createDefaultLayerPopupConfiguration(),
    joins: [],
  };

  return { source, layer };
}
